import { TabModel } from '../interfaces/tab-model-interface';

export const EDITOR_TABS: readonly TabModel[] = [
  {
    heading: 'Automation Hub',
    icon: 'element-ai-code',
    closable: false,
    active: true
  },
  {
    heading: 'Support Hub',
    icon: 'element-ai-support',
    closable: false,
    active: false
  }
] as const;
